type ServiceList = {
  id: number;
  serviceName: string;
  portalEnabled: boolean;
};

export type ItemWithServiceInfo = {
  services?: Array<number | string>;
  serviceIds?: Array<number | string>;
  serviceId?: number | string;
};

type RedirectFn = (commands: readonly string[]) => Promise<boolean>;

function hasAnyEnabledService(
  serviceIds: number[] | undefined,
  enabledServiceIds: number[],
): boolean {
  if (!Array.isArray(serviceIds) || serviceIds.length === 0) {
    return true;
  }

  return serviceIds.some((serviceId) => enabledServiceIds.includes(serviceId));
}

export function shouldIncludeItemByEnabledServices(
  item: ItemWithServiceInfo,
  enabledServiceIds: number[] | null,
): boolean {
  if (enabledServiceIds === null) {
    return true;
  }

  if (Array.isArray(item.services)) {
    if (item.services.length === 0) {
      return true;
    }

    return item.services.some((serviceId) =>
      enabledServiceIds.includes(Number(serviceId)),
    );
  }

  if (Array.isArray(item.serviceIds)) {
    if (item.serviceIds.length === 0) {
      return true;
    }

    return item.serviceIds.some((serviceId) =>
      enabledServiceIds.includes(Number(serviceId)),
    );
  }

  if (item.serviceId !== undefined && item.serviceId !== null) {
    return enabledServiceIds.includes(Number(item.serviceId));
  }

  return true;
}

export function redirectIfNoEnabledService(
  serviceIds: number[] | undefined,
  enabledServiceIds: number[],
  navigate: RedirectFn,
  redirectTo: string,
): boolean {
  if (hasAnyEnabledService(serviceIds, enabledServiceIds)) {
    return false;
  }

  navigate([redirectTo]).catch(() => undefined);

  return true;
}

export function getServiceNamesByIds(
  serviceIds: Array<number | string> | undefined,
  serviceMasterList: ServiceList[],
  delimiter = ', ',
): string {
  const serviceMap = new Map(
    serviceMasterList.map((s) => [s.id, s.serviceName]),
  );

  return Array.from(
    new Set(
      (serviceIds || [])
        .map((id) => serviceMap.get(Number(id)))
        .filter((name): name is string => Boolean(name)),
    ),
  ).join(delimiter);
}
